import { PencilIcon } from 'morpheus-ui';
import { useEffect, useState } from 'react';
import { Button } from '../../../../../core/components/atoms/Button';
import { Icon } from '../../../../../core/components/atoms/Icon';
import InnerHTMLContainer from '../../../../../core/components/molecules/InnerHTMLContainer';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { MaterialTypes } from '../../../models/Material.model';

interface MaterialCardItemProps {
  content: any;
  selected?: boolean;
  onClick: () => void;
  onClickDone: (contentId: string) => void;
}

function MaterialCardItem({
  content,
  selected,
  onClick,
  onClickDone,
}: MaterialCardItemProps) {
  const [isLoadingDone, setIsLoadingDone] = useState(false);
  const materialTypesInfos = {
    Exercise: { header: 'Lista de exercícios', footer: '', icon: 'mode' },
    Text: { header: 'Texto', footer: '', icon: 'subject' },
    Workbook: { header: 'Material', footer: 'Apostila', icon: 'library_books' },
    Practicetest: { header: 'Simulado', footer: '', icon: 'timer' },
    Mindmap: {
      header: 'Material',
      footer: 'Mapa mental',
      icon: 'library_books',
    },
    Live: { header: 'Live', footer: '', icon: 'live_tv' },
    Link: { header: 'Link Externo', footer: '', icon: 'link' },
    EssayActivity: { header: 'Enviar Redação', footer: '', icon: '' },
    Podcast: { header: 'Podcast', footer: '', icon: 'mic' },
  };

  const contentType = content.type as MaterialTypes;

  const materialInfo =
    materialTypesInfos[contentType as keyof typeof materialTypesInfos];

  let value = content.value ? content.value : content.target.title;
  let footer = materialInfo.footer;

  if (contentType === 'Text') {
    value = value.split('</p>')[0].replace(/<\/?[^>]+(>|$)/g, '');
  } else if (contentType === 'Link') {
    value = content.title;
  } else if (contentType === 'EssayActivity') {
    value = content.target.theme.theme;
  } else if (contentType === 'Exercise') {
    footer = content.targets
      ? `${content.targets.length} exercícios`
      : 'O exercícios';
  }

  useEffect(() => {
    setIsLoadingDone(false);
  }, [content.done]);

  return (
    <div
      className={`flex flex-col gap-sm rounded-md bg-color-lightest p-4 shadow-level-2 hover:cursor-pointer ${
        selected ? 'border-brand-color-primary-pure border-hairline' : ''
      }`}
      id={content._contentId}
      onClick={onClick}
    >
      <header className='flex items-center gap-sm'>
        <Icon
          Icon={
            contentType === 'EssayActivity' ? PencilIcon : materialInfo.icon
          }
          type={contentType === 'EssayActivity' ? 'svg' : 'material'}
          className='w-5 text-lg text-brand-color-secondary-pure'
        />
        <Typography type='titleSection' size='h6' className='w-full'>
          {materialInfo.header}
        </Typography>
        <Button
          iconId={`check-icon-${content.done ? 'done' : 'unseen'}`}
          variant='text'
          onlyIcon
          LeftIcon={'check_circle'}
          loading={isLoadingDone}
          disabled={content.done}
          classNameIcon={`${
            content.done ? 'text-feedback-color-success-pure' : 'text-mono-color-medium'
          } text-lg filled`}
          className='p-0'
          onClick={(e) => {
            e.stopPropagation();
            setIsLoadingDone(true);
            onClickDone(content._contentId);
          }}
        />
      </header>
      <main>
        <Typography type='title' size='h4' className='line-clamp-2'>
          <InnerHTMLContainer
            data={value}
            className='text-mono-color-darkest'
          />
        </Typography>
      </main>
      <footer className='flex items-center gap-sm'>
        <Typography size='small'>{footer}</Typography>
      </footer>
    </div>
  );
}

export { MaterialCardItem };
